export interface RevampedDebtRecordDto {
	id: string
	interestAmount: number | null
	principalAmount: number | null
	monthioCreditorId: number | null
	currency: string
	debtType: DebtRecordRevampedType | null
	loanStartDate: string | null
	description: string | null
	status: DebtRecordStatus
	realEstateId: string | null
	paymentId: string
	addedByApplicant: boolean
}

export type DebtRecordStatus = 'active' | 'unrecognized' | 'otherOwner' | 'paid'

export interface DebtPaymentDto {
	id: string
	currency: string
	monthioCreditorId: number | null
	paymentAmount: number | null
	frequency: 'monthly' | 'biMonthly' | 'quarterly' | 'biQuarterly' | 'yearly'
	debtRecordId: string
}

export interface DebtRecordRevamped {
	currency: string
	debtType: DebtRecordRevampedType | null
	description: string | null
	id: string
	monthioCreditorId: number | null
	status: DebtRecordStatus
	addedByApplicant: boolean
}

export enum DebtRecordRevampedType {
	Unknown = 'unknown',
	ConsumerLoan = 'consumerLoan',
	StudentLoan = 'studentLoan',
	MortgageByCreditInstitution = 'mortgageByCreditInstitution',
	MortgageByBank = 'mortgageByBank',
	CarLoan = 'carLoan',
	Overdraft = 'overdraft',
	OtherLoan = 'otherLoan',
	HomeLoan = 'homeLoan',
	BankLoan = 'bankLoan',
	DebtCollection = 'debtCollection',
	CreditCard = 'creditCard',
	PublicDebt = 'publicDebt',
	ForeignDebt = 'foreignDebt',
}

export type DebtOverviewDto = {
	[type: string]: DebtRecordDto
}

export type DebtRecordDto = {
	totalAmount: number
	monthlyAmount: number
}

export type DebtRecordSum = {
	totalAmountSum: number
	monthlyAmountSum: number
}

export enum DebtType {
	Mortgage = 'mortgage',
	CarLeasing = 'carLeasing',
	StudentLoans = 'studentLoans',
	BankLoans = 'bankLoans',
	ConsumerLoans = 'consumerLoans',
	Overdraft = 'overdraft',
	CreditCardRepayments = 'creditCardRepayments',
	OtherLoans = 'otherLoans',
	DebtCollection = 'debtCollection',
	PublicDebt = 'publicDebt',
}

export interface DebtOverviewModuleState {
    debtRecords: RevampedDebtRecordDto[]
    debtPayments: DebtPaymentDto[]
    allDebtPayments: DebtPaymentDto[]
    creditors: CreditorDto[]
}

export interface CreditorDto {
	id: number
	name: string
	logo: string | null | undefined
	BusinessIdentificationNumber: string
	regionId: string
}

export interface DebtRecordEstimatesRevampedDto {
	debtRecords: RevampedDebtRecordDto[]
	debtPayments: DebtPaymentDto[]
	allDebtPayments?: DebtPaymentDto[]
}